import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t py-14" style={{ backgroundColor: '#0D1811', borderColor: 'rgba(93,196,142,0.1)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <img
              src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/4ab61485feffac5558181f99f1be66f6.png"
              alt="Körperformen Pinneberg"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.4)' }}>
              Persönlich betreutes EMS-Training in Pinneberg.<br />
              20 Minuten pro Woche. Sichtbare Ergebnisse.
            </p>
            <div className="flex items-center gap-2 mt-5">
              <div className="flex gap-0.5">
                {[1,2,3,4,5].map(s => (
                  <div key={s} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="text-xs" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.35)' }}>5,0 · 20 Bewertungen · Google</span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.7)' }}>
              Navigation
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Vorteile', id: 'vorteile' },
                { label: 'So läuft es ab', id: 'angebot' },
                { label: 'Kundenstimmen', id: 'testimonials' },
                { label: 'Häufige Fragen', id: 'faq' },
                { label: 'Über das Studio', id: 'ueber-uns' },
              ].map(link => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-sm cursor-pointer transition-colors whitespace-nowrap"
                    style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.35)' }}
                    onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.7)')}
                    onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.35)')}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.7)' }}>
              Kontakt &amp; Studio
            </h4>
            <div className="space-y-3">
              {[
                { icon: 'ri-map-pin-2-line', text: 'Elmshorner Str. 3, 25421 Pinneberg' },
                { icon: 'ri-car-line', text: 'Parkplatz direkt vor dem Studio' },
                { icon: 'ri-phone-line', text: '0176 20023034', href: 'tel:017620023034' },
                { icon: 'ri-mail-line', text: 'Pinneberg@kformen.com', href: 'mailto:Pinneberg@kformen.com' },
                { icon: 'ri-time-line', text: 'Termine nach Vereinbarung' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-sm`} style={{ color: '#5DC48E', opacity: 0.7 }}></i>
                  </div>
                  {(item as { icon: string; text: string; href?: string }).href ? (
                    <a
                      href={(item as { icon: string; text: string; href?: string }).href}
                      className="text-sm transition-colors"
                      style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.4)' }}
                      onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.7)')}
                      onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.4)')}
                    >
                      {item.text}
                    </a>
                  ) : (
                    <span className="text-sm" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.4)' }}>
                      {item.text}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
          <p className="text-xs" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.25)' }}>
            &copy; {new Date().getFullYear()} Körperformen Pinneberg. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-5">
            <Link
              to="/impressum"
              className="text-xs transition-colors whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.25)' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.55)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.25)')}
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-xs transition-colors whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.25)' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.55)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.25)')}
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
